import React from 'react';

import { DivProps } from 'typings';
import * as S from './styles';

type TeamLogoProps = DivProps & {
  url?: string;
  name?: string;
  size?: number;
  className?: string;
  style?: React.CSSProperties;
};

const TeamLogo = (props: TeamLogoProps) => (
  <S.TeamLogoContainer {...props}>
    <S.TeamLogo logoUrl={props.url} />
  </S.TeamLogoContainer>
);

export default TeamLogo;
